/* eslint-disable @typescript-eslint/no-shadow */
import { FC, ReactNode } from 'react';

import HeaderNotification from '@/components/layouts/Header/HeaderNotification';

type LayoutProps = {
  story?: any;
  blok?: any;
  settingsNotifications: any;
  children?: ReactNode;
  footer?: boolean;
};

const Layout: FC<LayoutProps> = ({ children, settingsNotifications }) => {
  return (
    <>
      {settingsNotifications.stories ? (
        <HeaderNotification notifications={settingsNotifications.stories} />
      ) : null}
      {children}
    </>
  );
};

export default Layout;
